import { render, staticRenderFns } from "./VendorsProfileTabs.vue?vue&type=template&id=7da1f678&scoped=true"
import script from "./VendorsProfileTabs.vue?vue&type=script&lang=js"
export * from "./VendorsProfileTabs.vue?vue&type=script&lang=js"
import style0 from "./VendorsProfileTabs.vue?vue&type=style&index=0&id=7da1f678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1f678",
  null
  
)

export default component.exports